export default __webpack_public_path__ + "static/media/LogoPic.fbb93eb7.png";